import { Grid } from '@interstate/components/Grid';
import { Typography } from '@interstate/components/Typography';
import { kebabCase } from 'lodash';
import type { FC, ReactNode } from 'react';

type InfoDisplayFieldProps = {
    label: string;
    value: ReactNode;
};

export const InfoDisplayField: FC<InfoDisplayFieldProps> = ({ label, value }) => {
    return (
        <Grid
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'column'
            }}
        >
            <Typography
                data-testid={kebabCase(label)}
                sx={{ marginBottom: '0.714rem' }}
                variant="label-sm"
                color="sem.color.on-surface.muted"
            >
                {label}
            </Typography>
            <Typography variant="label-md" sx={{ height: '20px', display: 'grid', alignItems: 'end' }}>
                {value}
            </Typography>
        </Grid>
    );
};
